import { z } from "zod";

const smsSettingsZodObject = z.object({
    _id: z.literal("sms_settings"),
    _type: z.literal("SMS_SETTINGS"),
    smsProvider: z.enum(["twilio", "46elks", "test"]).default("46elks"),
    authSmsProvider: z.enum(["twilio", "46elks", "test"]).default("46elks"),
    regexPhoneNumberBlocks: z.array(z.string()).optional(),
    blockedCountryCodes: z.array(z.string()).optional(),
    callbackUrl: z.string(),
});

type SmsSettings = z.infer<typeof smsSettingsZodObject>;

const smsSettingsZodScheme = smsSettingsZodObject as z.ZodSchema<SmsSettings>;

export { smsSettingsZodObject, smsSettingsZodScheme };
export type { SmsSettings };
